export default __webpack_public_path__ + "assets/da2fcc3fa42d58f89f4ee84106584129.png";